//#region src/service_actor.ts
function toServicePrincipal({ name }) {
	return {
		kind: "Service",
		name
	};
}
//#endregion
export { toServicePrincipal };

//# sourceMappingURL=service_actor.js.map